import { useEffect, useRef, useState } from "react";
import { pub, mediaUrl } from "@/lib/api";

// Eve's takeover of the private poster page: glitch → poster freezes → full-screen Eve video → cyan line + Continue.
// Plays once per player (remembered on the server); "replay signal" plays it again.
export function useEve(id, k, eve) {
  const [phase, setPhase] = useState("idle");  // idle → glitch → video → after
  const [after, setAfter] = useState(!!eve?.done);
  useEffect(() => { if (eve?.done) setAfter(true); }, [eve?.done]);  // config arrives after first render
  const post = (event) => pub.post(`/poster/${id}/eve`, { event }, { params: { k } }).then((r) => r.data).catch(() => ({}));
  const start = () => {
    setPhase("glitch");
    setTimeout(() => { setPhase("video"); post("seen"); }, 900);
  };
  useEffect(() => {
    if (!eve?.video || eve.seen) return undefined;
    const t = setTimeout(start, 4000);
    return () => clearTimeout(t);
  }, [eve?.video, eve?.seen]);  // eslint-disable-line react-hooks/exhaustive-deps
  const finish = (watched) => { if (watched) post("done"); setPhase("idle"); setAfter(true); };
  return { phase, after, start, finish, post };
}

export function EveVideo({ onEnd }) {
  const ref = useRef(null);
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const v = ref.current;
    v.play().catch(() => setBlocked(true));  // autoplay with sound blocked → tap to play
  }, []);
  const tap = () => { setBlocked(false); ref.current.play().catch(() => setBlocked(true)); };
  return (
    <div data-testid="eve-overlay" className="eve-overlay fixed inset-0 z-[80] flex items-center justify-center bg-black">
      <video ref={ref} data-testid="eve-video" src={mediaUrl("eve_intro")} playsInline preload="auto"
        onEnded={() => onEnd(true)} onError={() => onEnd(false)} className="max-h-full max-w-full object-contain" />
      {blocked && (
        <button type="button" onClick={tap} data-testid="eve-tap-to-play"
          className="eve-tap absolute inset-0 flex items-center justify-center font-mono text-sm tracking-[0.4em] text-[#5ee6e6]">
          TAP TO RECEIVE
        </button>
      )}
    </div>
  );
}

export function EveLine({ post }) {
  const [panel, setPanel] = useState(false);
  const go = async () => {
    await post("continue");  // Phase 2: when STRIPE_ENABLED is true this response's `stripe` flag will route to checkout
    setPanel(true);
  };
  return (
    <div data-testid="eve-line" className="eve-in mt-10 border-t border-[#5ee6e6]/20 pt-6 font-mono">
      <p className="text-base tracking-[0.04em] text-[#5ee6e6] [text-shadow:0_0_10px_rgba(94,230,230,.45)]" data-testid="eve-line-text">Find out who M really was.</p>
      <button type="button" onClick={go} data-testid="eve-continue-button"
        className="mt-4 border border-[#5ee6e6] px-5 py-2.5 text-xs tracking-[0.3em] text-[#5ee6e6] transition-colors hover:bg-[#5ee6e6] hover:text-black">CONTINUE</button>
      {panel && (
        <p data-testid="eve-decoding-panel" className="eve-in mt-4 max-w-md border border-[#5ee6e6]/30 bg-[#5ee6e6]/5 p-4 text-sm leading-6 text-[#bff5f5]">
          The signal is still being decoded. You'll hear from us.
        </p>
      )}
    </div>
  );
}
